<div [class]="classList">
  <!-- link preview mode -->
  <div *ngIf="isLinked" class="d-flex align-items-center">
    <lib-form-label [label]="label" [isRequired]="isRequired"></lib-form-label>

    <div class="d-flex align-items-center justify-content-between w-100">
      <a
        [href]="control?.value"
        target="_blank"
        class="flex-grow-1"
        [class.text-decoration-none]="!control?.value"
      >
        <div
          class="form-control div-form-control"
          [class.cursor-pointer]="control?.value"
        >
          {{ control?.value || placeholder }}
        </div>
      </a>

      <div *ngIf="icon" class="avatar-xs ms-2">
        <span class="avatar-title rounded-circle font-size-16" [class]="iconColor">
          <i [class]="icon"></i>
        </span>
      </div>
    </div>
  </div>

  <!-- regular input mode -->
  <div *ngIf="!isLinked">
    <lib-form-label [label]="label" [isRequired]="isRequired">
      <span
        *ngIf="!isHideTooltip"
        class="font-size-18 cursor-pointer"
        [ngbTooltip]="helpTooltipTemplate"
        #tt="ngbTooltip"
        container="body"
        (mouseout)="tt.close()"
        triggers="click:blur"
      >
        <i class="bx bx-question-mark mb-0 text-info"></i>
      </span>

      <ng-template #helpTooltipTemplate>
        <div class="text-start" *ngIf="urlHelpTooltip">{{ urlHelpTooltip }}</div>
          <div *ngIf="!urlHelpTooltip" class="text-start">{{ "common.error.secureUrl" | transloco: { field: label } }}</div>
        <div *ngFor="let item of tooltipItems" class="text-start">{{ item }}</div>
      </ng-template>
    </lib-form-label>

    <!-- icon inside -->
    <div *ngIf="iconInside" class="position-relative">
      <span class="position-absolute top-50 translate-middle-y" [style.left.px]="30">
        <img
          *ngIf="iconSvg"
          class="icon icon-xs icon-rounded"
          [src]="iconSvg"
          [alt]="iconSvg"
        />
        <i *ngIf="!iconSvg && iconInside" [class]="iconInside" [style.color]="iconInsideColor"></i>
      </span>

      <lib-url-input
        [control]="control"
        [inputId]="inputId || label"
        [placeholder]="placeholder"
        [readonly]="readonly"
        [classList]="''"
        [innerClassList]="'form-control ps-5 ' + innerClassList"
        [errorClassList]="errorClassList"
        [trimOnFocusOut]="trimOnFocusOut"
        (focus)="focus.emit($event)"
        (blur)="blur.emit($event)"
      />
    </div>

    <!-- external icon -->
    <div *ngIf="!iconInside" class="d-flex align-items-start">
      <div class="flex-grow-1">
        <lib-url-input
          [control]="control"
          [inputId]="inputId || label"
          [placeholder]="placeholder"
          [readonly]="readonly"
          [classList]="''"
          [innerClassList]="innerClassList"
          [errorClassList]="errorClassList"
          [icon]="icon"
          [iconTooltip]="iconTooltip"
          [clickableIconWhenDisabled]="clickableIconWhenDisabled"
          [trimOnFocusOut]="trimOnFocusOut"
          (iconClick)="iconClick.emit()"
          (focus)="focus.emit($event)"
          (blur)="blur.emit($event)"
        />
      </div>

      <div *ngIf="icon && !iconInside" class="avatar-xs ms-2">
        <span class="avatar-title rounded-circle font-size-16" [class]="iconColor">
          <i [class]="icon"></i>
        </span>
      </div>
    </div>
  </div>
</div>
